module.exports = __webpack_public_path__ + "fonts/fa-regular-400.27a4e6fd.woff2";